// extracted by mini-css-extract-plugin
module.exports = {"numberBox":"NumberWidget_numberBox__QmNeS","disabled":"NumberWidget_disabled__3xyvH","withFloatingLabel":"NumberWidget_withFloatingLabel__3_RGW"};